export function createEmptySaveData() {
  return {
    backgroundColor: '#3e4272',
    top10: [[],[],[]],
    mute: false,
    nickname: '',
    animations: true
  };
}